module.exports = __webpack_public_path__ + "static/media/ip_publique.efe8f88d.PNG";